export default __webpack_public_path__ + "static/media/Original.e82859a4.png";